import { createContext, useContext, useState, ReactNode } from "react";

interface PortalContextType {
  session: string | null;
  login: (sessionId: string) => void;
  logout: () => void;
}

const PortalContext = createContext<PortalContextType | null>(null);

interface PortalProviderProps {
  children: ReactNode;
}

export function PortalProvider({ children }: PortalProviderProps) {
  const [session, setSession] = useState<string | null>(
    localStorage.getItem("portalSessionId") || null
  );

  const login = (sessionId: string) => {
    localStorage.setItem("portalSessionId", sessionId);
    setSession(sessionId);
  };

  const logout = async () => {
    // Call logout endpoint
    if (session) {
      try {
        await fetch("/portal/logout", {
          method: "POST",
          headers: { "x-portal-session": session },
        });
      } catch (error) {
        console.error("Logout error:", error);
      }
    }
    
    localStorage.removeItem("portalSessionId");
    setSession(null);
  };

  return (
    <PortalContext.Provider value={{ session, login, logout }}>
      {children}
    </PortalContext.Provider>
  );
}

export const usePortal = () => {
  const context = useContext(PortalContext);
  if (!context) {
    throw new Error("usePortal must be used within PortalProvider");
  }
  return context;
};
